import React, { useState, useEffect } from 'react';
import { getHistorialKardex } from '../../../services/KardexService';

// Estilos
import '../../static/Global.css';
import '../../static/Home.css';
import '../../static/Aside.css';
import '../../static/Flotante.css';
import '../../static/Busqueda.css';

function DashboardKardex() {
    // 1. Estados
    const [movimientos, setMovimientos] = useState([]);
    const [busqueda, setBusqueda] = useState("");
    const [loading, setLoading] = useState(true);

    // 2. Carga de datos
    const cargarKardex = async () => {
        setLoading(true);
        try {
            const data = await getHistorialKardex();
            setMovimientos(data);
        } catch (error) {
            console.error("Error al cargar Kardex:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        cargarKardex();
    }, []);

    // 3. Estilos dinámicos para los movimientos
    const getBadgeStyle = (tipo) => {
        switch (tipo) {
            case 'ENTRADA': 
                return { backgroundColor: '#dcfce7', color: '#15803d', padding: '4px 8px', borderRadius: '6px', fontWeight: 'bold', fontSize: '0.85rem' };
            case 'SALIDA': 
                return { backgroundColor: '#fee2e2', color: '#b91c1c', padding: '4px 8px', borderRadius: '6px', fontWeight: 'bold', fontSize: '0.85rem' };
            case 'ENTRADA_ANULACION': 
                return { backgroundColor: '#e0f2fe', color: '#0369a1', padding: '4px 8px', borderRadius: '6px', fontWeight: 'bold', fontSize: '0.85rem' };
            default: 
                return { backgroundColor: '#f1f5f9', color: '#475569', padding: '4px 8px', borderRadius: '6px', fontWeight: 'bold', fontSize: '0.85rem' };
        }
    };

            //Lógica de filtrado 
const movimientosFiltrados = movimientos.filter(m => 
    m.producto_nombre?.toLowerCase().includes(busqueda.toLowerCase()) ||
    m.articulo_id?.toString().includes(busqueda) ||
    m.tipo_movimiento?.toLowerCase().includes(busqueda.toLowerCase()) ||
    m.referencia_id?.toString().includes(busqueda)
);

return (
    <section className="main__content">
        <div className="table-container">
            <div className="table-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', gap: '20px' }}>
                <h2>KARDEX DE INVENTARIO</h2>

                {/* BARRA DE BÚSQUEDA */}
                <div className="search-container" >
                    <i className="fa fa-search" style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#888' }}></i>
                    <input 
                        type="text"
                        className="search-input" // Usa la clase de tu CSS anterior
                        placeholder="Buscar producto, ID o tipo..."
                        value={busqueda}
                        onChange={(e) => setBusqueda(e.target.value)}
                    />
                </div>
                
                <button type="button" className="btn-vender-sidebar" onClick={() => cargarKardex()}>
                    <i className="fa fa-sync"></i> Actualizar
                </button>
            </div>

            <div className="table-responsive">
                <table className="novatech-table">
                    <thead>
                        <tr>
                            <th>Fecha y Hora</th>
                            <th>Producto</th>
                            <th>Tipo Movimiento</th>
                            <th>Origen</th>
                            <th>ID Ref.</th>
                            <th>Cantidad</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr><td colSpan="7">Cargando movimientos...</td></tr>
                        ) : movimientosFiltrados.length === 0 ? (
                            <tr><td colSpan="7" style={{textAlign: 'center', padding: '20px'}}>No se encontraron movimientos.</td></tr>
                        ) : (
                            // CAMBIO AQUÍ: Usamos movimientosFiltrados
                            movimientosFiltrados.map((m) => (
                                <tr key={m.kardex_id}>
                                    <td style={{ fontSize: '0.85rem' }}>
                                        {new Date(m.fecha).toLocaleString()}
                                    </td>
                                    <td>
                                        <strong>{m.producto_nombre}</strong>
                                        <br />
                                        <small style={{ color: '#888' }}>ID Art: #{m.articulo_id}</small>
                                    </td>
                                    <td>
                                        <span style={getBadgeStyle(m.tipo_movimiento)}>
                                            {m.tipo_movimiento}
                                        </span>
                                    </td>
                                    <td>{m.tabla_referencia}</td>
                                    <td>#{m.referencia_id}</td>
                                    <td style={{ 
                                        fontWeight: 'bold', 
                                        color: m.tipo_movimiento === 'SALIDA' ? '#b91c1c' : '#15803d' 
                                    }}>
                                        {m.tipo_movimiento === 'SALIDA' ? `- ${m.cantidad}` : `+ ${m.cantidad}`}
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    </section>
);

}

export default DashboardKardex;